import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { PricingProvider } from "@/context/PricingContext";
import { CartProvider } from "@/context/CartContext";
import { DemoModalProvider, useDemoModal } from "@/context/DemoModalContext";
import ScrollToTop from "@/components/ScrollToTop";
import FloatingScrollToTopButton from "@/components/FloatingScrollToTopButton";
import CookieConsentLayer from "@/components/CookieConsentLayer";
import CartDrawer from "@/components/CartDrawer";
import DemoRequestModal from "@/components/DemoRequestModal";
import FreePlanModal from "@/components/FreePlanModal";
import LandingPage from "@/pages/LandingPage";
import QuienesSomosPage from "@/pages/QuienesSomosPage";
import ComparativaPlanesPage from "@/pages/ComparativaPlanesPage";
import ContactPage from "@/pages/ContactPage";
import CheckoutPage from "@/pages/CheckoutPage";
import SubscripcionConfirmadaPage from "@/pages/SubscripcionConfirmadaPage";
import CookiesPolicyPage from "@/pages/CookiesPolicyPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsConditionsPage from "@/pages/TermsConditionsPage";

/** Conecta FreePlanModal (controlado por props) al estado global independiente. */
function GlobalFreePlanModal() {
  const { freeOpen, closeFreeModal } = useDemoModal();
  return <FreePlanModal open={freeOpen} onClose={closeFreeModal} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <PricingProvider>
      <DemoModalProvider>
        <CartProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/quienes-somos" element={<QuienesSomosPage />} />
            <Route path="/comparativa-planes" element={<ComparativaPlanesPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/pago" element={<CheckoutPage />} />
            <Route path="/subscripcion-confirmada" element={<SubscripcionConfirmadaPage />} />
            <Route path="/cookies" element={<CookiesPolicyPage />} />
            <Route path="/privacidad" element={<PrivacyPolicyPage />} />
            <Route path="/terminos-condiciones" element={<TermsConditionsPage />} />
          </Routes>
          <CartDrawer />
          <DemoRequestModal />
          <GlobalFreePlanModal />
          <CookieConsentLayer />
          <FloatingScrollToTopButton />
        </CartProvider>
      </DemoModalProvider>
      </PricingProvider>
    </BrowserRouter>
  );
}
